import { supabase } from '../lib/supabase';

export const companyService = {
  async getAll() {
    const { data, error } = await supabase?.from('companies')?.select('*')?.order('name');

    if (error) throw error;

    // Convert snake_case to camelCase
    return data?.map(row => ({
      id: row?.id,
      name: row?.name,
      type: row?.type,
      logoUrl: row?.logo_url,
      description: row?.description,
      createdAt: row?.created_at,
    }));
  },

  async getById(id) {
    const { data, error } = await supabase?.from('companies')?.select('*')?.eq('id', id)?.single();

    if (error) throw error;

    return {
      id: data?.id,
      name: data?.name,
      type: data?.type,
      logoUrl: data?.logo_url,
      description: data?.description,
      createdAt: data?.created_at,
    };
  },
};